import withSharedStyles from "../theme/Shared.style";

const withCustomStyles = withSharedStyles(theme => {
  const { color, radius, shadow, control, fontSize } = theme.tokens;

  return {
    wrap: {
      position: "sticky",
      bottom: 20,
      zIndex: 15,
      display: "flex",
      justifyContent: "center",
      pointerEvents: "none",
      // own space at the end of the page (a negative margin overlapped the
      // content of short pages such as the 404)
      marginTop: 24,
      marginBottom: -48,
      padding: `0 ${theme.layout.gutterMobile}px`
    },
    bar: {
      pointerEvents: "auto",
      height: control.lg,
      maxWidth: "100%",
      boxSizing: "border-box",
      padding: "0 8px 0 24px",
      borderRadius: radius.pill,
      backgroundColor: color.ink,
      color: color.bg,
      display: "flex",
      alignItems: "center",
      gap: 20,
      boxShadow: shadow.overlay,
      textDecoration: "none",
      "&:hover": { backgroundColor: color.inkRaised, color: color.bg }
    },
    count: {
      fontSize: fontSize.body,
      fontWeight: 600,
      whiteSpace: "nowrap"
    },
    cta: {
      height: control.sm,
      padding: "0 20px",
      borderRadius: radius.pill,
      backgroundColor: color.bg,
      color: color.ink,
      display: "flex",
      alignItems: "center",
      fontWeight: 800,
      fontSize: fontSize.body,
      whiteSpace: "nowrap"
    }
  };
});

export default withCustomStyles;
